var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.moment(_vm.date).format('DD-MM-YYYY')))]),_c('br'),_vm._v("\n    at "),_c('span',[_vm._v(_vm._s(_vm.moment(_vm.date).format('HH:mm')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }